(function (angular, app) {
    'use strict';

    app.service('LoyaltyIFrameDialog', ['Dialog', function (Dialog) {
        this.show = show;
        this.hide = hide;

        function show(url, data) {
            setTimeout(function() {
                document.getElementById('iframe-not-loaded').style.display = 'none';
            }, 1500)
            return Dialog.show({
                templateUrl: 'template/dialogs/loyalty-iframe/index.html',
                controller: 'LoyaltyIFrameCtrl as loyaltyIframeCtrl',
                styleClass: 'loyalty-iframe-dialog',
                showClose: false,
                disableClosing: true,
                locals: {
                    url: url,
                    data: data
                }
            });
        }

        function hide() {
            Dialog.hide();
        }
    }]);

    app.directive('iframeOnload', [function() {
        return {
            scope: {
                callBack: '&iframeOnload'
            },
            link: function(scope, element) {
                element.on('load', function(){
                    return scope.callBack();
                })
            }
        }
    }]);

    app.run(['$rootScope', 'LoyaltyIFrameDialog', function ($rootScope, LoyaltyIFrameDialog) {
        $rootScope.LoyaltyIFrameDialog = LoyaltyIFrameDialog;
    }]);

    app.controller('LoyaltyIFrameCtrl', ['$rootScope', 'User', 'url', 'data',
        function ($rootScope, User, iframeUrl, data) {
            var loyaltyIframeCtrl = this;
            angular.extend(loyaltyIframeCtrl, {
                iframeUrl: iframeUrl,
                iframeLoaded: iframeLoaded,
                closeDialog: closeDialog
            });

            window.addEventListener("message", function(e) {
                if(e.data === 'ready'){
                    iframeLoaded()
                }
                else {
                    //if (e.origin == iframeUrl) {
                    if (e.data.isSuccess) {
                        User.getData(true).then(function (userData) {
                            if (userData.foreignId) {
                                closeDialog();
                            } else {
                                document.getElementById('loyalty_iframe').src += '';
                            }
                        });
                    }
                    //}
                }
            });

            function iframeLoaded() {
                document.getElementById('loyalty_iframe').contentWindow.postMessage(data, iframeUrl);
            }

            function closeDialog() {
                $rootScope.LoyaltyIFrameDialog.hide();
            }
        }]);
})(angular, app);
